import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaWhatsapp } from "react-icons/fa";

const linkClass = "text-white/70 hover:text-yellow-300 transition";

const Footer = () => (
  <footer className="bg-green-950 text-white w-full">
    <div className="max-w-6xl mx-auto px-6 py-12 grid gap-10 md:grid-cols-3 text-left">
      <div>
        <h3 className="text-xl font-black text-yellow-300 mb-3">
          REVIBE HEALTH AND HAPPINESS
        </h3>
        <p className="text-sm text-white/70 leading-relaxed mb-3">
          Sustainable weight loss through Ayurveda and Neuroscience.
        </p>
        <p className="text-xs text-white/60 leading-relaxed">
          Partnership Firm
          <br />
          GSTIN: 27ABLFR6155M1ZH
          <br />
          PAN: ABLFR6155M
        </p>
      </div>

      <div>
        <h4 className="text-sm font-bold uppercase tracking-wider text-yellow-300 mb-3">
          Registered Office
        </h4>
        <p className="flex gap-3 text-sm text-white/70 leading-relaxed">
          <FaMapMarkerAlt className="mt-1 shrink-0 text-yellow-300" />
          <span>
            2206, 22nd Floor, Solus, Hiranandani Estate, Patlipada, Near
            Hiranandani School, Thane, Maharashtra - 400607, India
          </span>
        </p>
      </div>

      <div>
        <h4 className="text-sm font-bold uppercase tracking-wider text-yellow-300 mb-3">
          Contact
        </h4>
        <ul className="space-y-2 text-sm text-white/70">
          <li className="flex gap-3 items-center">
            <FaPhoneAlt className="text-yellow-300" /> +91-9967756867
          </li>
          <li className="flex gap-3 items-center">
            <FaEnvelope className="text-yellow-300" /> support@swapnilgautam.com
          </li>
          <li className="flex gap-3 items-start">
            <FaWhatsapp className="text-yellow-300 mt-1 shrink-0" />
            <span>
              Official WhatsApp: +91-9967756867
              <br />
              <span className="text-white/50">(Business hours 10AM-7PM IST)</span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col items-center gap-4 text-center">
        <nav className="flex items-center justify-center gap-x-6 gap-y-2 text-sm flex-wrap">
          <Link to="/about" className={linkClass}>About Us</Link>
          <Link to="/privacy-policy" className={linkClass}>Privacy Policy</Link>
          <a href="#" className={linkClass}>Terms & Conditions</a>
          <Link to="/refund-policy" className={linkClass}>Refund Policy</Link>
          <a href="mailto:support@swapnilgautam.com" className={linkClass}>Contact Us</a>
        </nav>
        <p className="text-xs text-white/50">
          Programs by: Swapnil Gautam, Partner - Revibe Health and Happiness
        </p>
        <p className="text-xs text-white/50">
          © 2026 REVIBE HEALTH AND HAPPINESS
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
